function toDayKey(value) {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function formatDayLabel(dayKey) {
  if (!dayKey) return '—';
  const date = new Date(`${dayKey}T12:00:00`);
  if (Number.isNaN(date.getTime())) return dayKey;
  return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
}

export function aggregateDailyProfileUploads(profiles = []) {
  const counts = new Map();

  profiles.forEach((profile) => {
    const dayKey = toDayKey(profile?.uploadedOn);
    if (!dayKey) return;
    counts.set(dayKey, (counts.get(dayKey) || 0) + 1);
  });

  return Array.from(counts.entries())
    .map(([date, count]) => ({
      date,
      sortKey: date,
      count,
      label: formatDayLabel(date),
    }))
    .sort((a, b) => a.date.localeCompare(b.date));
}

export default aggregateDailyProfileUploads;
